module.exports = __webpack_public_path__ + "static/media/ball.d0bdb734.png";